import { Currency } from '@pegasus/translation';
export var Environment;
(function (Environment) {
    Environment["DEVELOPMENT"] = "development";
    Environment["DEVELOPMENT_PRODUCTION"] = "development-production";
    Environment["LOCAL_PRODUCTION"] = "local-production";
    Environment["PREVIEW"] = "preview";
    Environment["PRODUCTION"] = "production";
    Environment["RELEASE"] = "release";
    Environment["REVIEW"] = "review";
    Environment["STAGING"] = "staging";
    Environment["TEST"] = "test";
    Environment["UPCOMING"] = "upcoming";
})(Environment || (Environment = {}));
export const AppDomain = {
    Germany: 17,
    France: 18,
    Netherlands: 35,
    Belgium: 36,
    BelgiumFR: 37,
    Austria: 39,
    Switzerland: 40,
    SwitzerlandFR: 41,
    GreatBritain: 43,
    Italy: 44,
    Poland: 45,
    Spain: 46,
    CzechRepublic: 51,
    Sweden: 60,
    Denmark: 61,
    Finland: 62,
    Norway: 63,
    Estonia: 64,
    Latvia: 65,
    Lithuania: 66,
    Slovakia: 67,
    Slovenia: 68,
    Croatia: 69,
    Portugal: 70,
    Romania: 71,
    Hungary: 75,
    LuxembourgFR: 76,
    LuxembourgDE: 77,
};
export const CountryCode = {
    Germany: 'DE',
    France: 'FR',
    Netherlands: 'NL',
    Belgium: 'BE',
    Austria: 'AT',
    Switzerland: 'CH',
    GreatBritain: 'GB',
    Italy: 'IT',
    Poland: 'PL',
    Spain: 'ES',
    CzechRepublic: 'CZ',
    Sweden: 'SE',
    Denmark: 'DK',
    Finland: 'FI',
    Norway: 'NO',
    Lithuania: 'LT',
    Slovakia: 'SK',
    Portugal: 'PT',
    Romania: 'RO',
    Estonia: 'EE',
    Latvia: 'LV',
    Slovenia: 'SI',
    Croatia: 'HR',
    Hungary: 'HU',
    Luxembourg: 'LU',
};
export const SalesChannel = {
    Germany: '549a0fed-e0f1-45fa-83ad-b5a16080ff22',
    France: 'a332da49-a665-4a13-bd44-1ecea09b4d86',
    Netherlands: 'c2cc09de-7d7a-440b-ad6c-35527625b07e',
    Belgium: 'e42097e0-7bcf-434a-8647-4b06ea43e6d4',
    Austria: '92420e60-86b5-4d0b-af28-3d896571b019',
    Switzerland: 'e4c5d078-d823-4232-aba9-6eb1e4e5297d',
    GreatBritain: 'c3e00c90-1edd-48bb-801a-ec5b73ecaf74',
    Italy: '9519fbb0-4ff6-4525-ab9c-f526919ec803',
    Poland: 'e5168407-8d6f-4d9d-95e1-7e6fa5a6382c',
    Spain: 'b69973d1-d62f-4fd2-89a8-1dfed090b6be',
    CzechRepublic: '26495c23-5f23-4e07-a781-8f553efaa8f2',
    Sweden: 'a846387b-b1c9-4022-a1ff-493bfd9a151a',
    Denmark: 'fe2d5963-cd83-49bc-a08e-71be666c92ed',
    Finland: '379ce4e7-cd4f-40d6-a714-44bf9a2e3ff6',
    Norway: 'bcf9b34a-d0dd-4f24-a6c7-ff209c617444',
    Lithuania: 'b965c140-1762-4d2f-bccb-bf4ded87ffb6',
    Slovakia: '2825a48f-a3c4-4e87-ae97-7b3a730a6e2a',
    Portugal: '07e4c8f3-ba6e-437c-8741-f0e74fd9df42',
    Romania: '3ff74d5b-2386-4958-a14f-c70a945e7db1',
    Croatia: '989f26e4-e629-407a-a3de-1553bf5dc218',
    Estonia: '97755013-8e63-4bb5-91a1-4cb3d3ffde49',
    Hungary: '7fe08bb4-240e-4d29-ac16-445597aec6f3',
    Latvia: 'aa954789-12b7-4f8d-a168-9c7f6b27d903',
    Slovenia: 'b1891739-13c7-4534-9d70-2606ead6e2a3',
    Luxembourg: 'd8fdaa2a-a059-4290-8558-97426180600f',
};
export const CountryCodeBySalesChannel = {
    [SalesChannel.Germany]: CountryCode.Germany,
    [SalesChannel.France]: CountryCode.France,
    [SalesChannel.Netherlands]: CountryCode.Netherlands,
    [SalesChannel.Belgium]: CountryCode.Belgium,
    [SalesChannel.Austria]: CountryCode.Austria,
    [SalesChannel.Switzerland]: CountryCode.Switzerland,
    [SalesChannel.GreatBritain]: CountryCode.GreatBritain,
    [SalesChannel.Italy]: CountryCode.Italy,
    [SalesChannel.Poland]: CountryCode.Poland,
    [SalesChannel.Spain]: CountryCode.Spain,
    [SalesChannel.CzechRepublic]: CountryCode.CzechRepublic,
    [SalesChannel.Sweden]: CountryCode.Sweden,
    [SalesChannel.Denmark]: CountryCode.Denmark,
    [SalesChannel.Finland]: CountryCode.Finland,
    [SalesChannel.Norway]: CountryCode.Norway,
    [SalesChannel.Lithuania]: CountryCode.Lithuania,
    [SalesChannel.Slovakia]: CountryCode.Slovakia,
    [SalesChannel.Portugal]: CountryCode.Portugal,
    [SalesChannel.Romania]: CountryCode.Romania,
    [SalesChannel.Croatia]: CountryCode.Croatia,
    [SalesChannel.Estonia]: CountryCode.Estonia,
    [SalesChannel.Hungary]: CountryCode.Hungary,
    [SalesChannel.Latvia]: CountryCode.Latvia,
    [SalesChannel.Slovenia]: CountryCode.Slovenia,
    [SalesChannel.Luxembourg]: CountryCode.Luxembourg,
};
export const CurrencyByCountryCode = {
    [CountryCode.Germany]: Currency.EUR,
    [CountryCode.France]: Currency.EUR,
    [CountryCode.Netherlands]: Currency.EUR,
    [CountryCode.Belgium]: Currency.EUR,
    BENL: Currency.EUR,
    BEFR: Currency.EUR,
    [CountryCode.Austria]: Currency.EUR,
    [CountryCode.Switzerland]: Currency.CHF,
    CHDE: Currency.CHF,
    CHFR: Currency.CHF,
    [CountryCode.GreatBritain]: Currency.GBP,
    [CountryCode.Italy]: Currency.EUR,
    [CountryCode.Poland]: Currency.PLN,
    [CountryCode.Spain]: Currency.EUR,
    [CountryCode.CzechRepublic]: Currency.CZK,
    [CountryCode.Sweden]: Currency.SEK,
    [CountryCode.Denmark]: Currency.DKK,
    [CountryCode.Finland]: Currency.EUR,
    [CountryCode.Norway]: Currency.NOK,
    [CountryCode.Lithuania]: Currency.EUR,
    [CountryCode.Slovakia]: Currency.EUR,
    [CountryCode.Portugal]: Currency.EUR,
    [CountryCode.Romania]: Currency.RON,
    [CountryCode.Hungary]: Currency.HUF,
    [CountryCode.Luxembourg]: Currency.EUR,
    [CountryCode.Estonia]: Currency.EUR,
    [CountryCode.Latvia]: Currency.EUR,
    [CountryCode.Slovenia]: Currency.EUR,
    [CountryCode.Croatia]: Currency.EUR,
    FRLU: Currency.EUR,
    DELU: Currency.EUR,
};
/**
 * Retrieving country code based on the `AppDomain` is deprecated as it is misleading
 * because it returns a combination of country code and locale code.
 *
 * Use `CountryCodeBySalesChannel` instead to retrieve real country code.
 *
 * @deprecated
 */
export const CountryCodeByAppDomain = {
    [AppDomain.Germany]: CountryCode.Germany,
    [AppDomain.France]: CountryCode.France,
    [AppDomain.Netherlands]: CountryCode.Netherlands,
    [AppDomain.Belgium]: `${CountryCode.Belgium}NL`,
    [AppDomain.BelgiumFR]: `${CountryCode.Belgium}FR`,
    [AppDomain.Austria]: CountryCode.Austria,
    [AppDomain.Switzerland]: `${CountryCode.Switzerland}DE`,
    [AppDomain.SwitzerlandFR]: `${CountryCode.Switzerland}FR`,
    [AppDomain.GreatBritain]: CountryCode.GreatBritain,
    [AppDomain.Italy]: CountryCode.Italy,
    [AppDomain.Poland]: CountryCode.Poland,
    [AppDomain.Spain]: CountryCode.Spain,
    [AppDomain.CzechRepublic]: CountryCode.CzechRepublic,
    [AppDomain.Sweden]: CountryCode.Sweden,
    [AppDomain.Denmark]: CountryCode.Denmark,
    [AppDomain.Finland]: CountryCode.Finland,
    [AppDomain.Norway]: CountryCode.Norway,
    [AppDomain.Lithuania]: CountryCode.Lithuania,
    [AppDomain.Slovakia]: CountryCode.Slovakia,
    [AppDomain.Portugal]: CountryCode.Portugal,
    [AppDomain.Romania]: CountryCode.Romania,
    [AppDomain.Estonia]: CountryCode.Estonia,
    [AppDomain.Latvia]: CountryCode.Latvia,
    [AppDomain.Slovenia]: CountryCode.Slovenia,
    [AppDomain.Croatia]: CountryCode.Croatia,
    [AppDomain.Hungary]: CountryCode.Hungary,
    [AppDomain.LuxembourgFR]: CountryCode.Luxembourg,
    [AppDomain.LuxembourgDE]: CountryCode.Luxembourg,
};
//# sourceMappingURL=constants.js.map